"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Maybe_1 = require("./Maybe");
exports.Either = {
    of: function (value) {
        return right(value);
    },
    lefts: function (list) {
        return list.filter(function (x) { return x.isLeft(); }).map(function (x) { return x.__value; });
    },
    rights: function (list) {
        return list.filter(function (x) { return x.isRight(); }).map(function (x) { return x.__value; });
    },
    encase: function (throwsF) {
        try {
            return right(throwsF());
        }
        catch (e) {
            return left(e);
        }
    },
    'fantasy-land/of': function (value) {
        return exports.Either.of(value);
    }
};
var Right = /** @class */ (function () {
    function Right(value) {
        this.__value = value;
    }
    Right.prototype.isLeft = function () {
        return false;
    };
    Right.prototype.isRight = function () {
        return true;
    };
    Right.prototype.toJSON = function () {
        return this.__value;
    };
    Right.prototype.inspect = function () {
        return "Right(" + JSON.stringify(this.__value) + ")";
    };
    Right.prototype.toString = function () {
        return this.inspect();
    };
    Right.prototype.bimap = function (_, g) {
        return right(g(this.__value));
    };
    Right.prototype.map = function (f) {
        return right(f(this.__value));
    };
    Right.prototype.mapLeft = function (_) {
        return this;
    };
    Right.prototype.ap = function (other) {
        return other.isLeft() ? other : this.map(other.__value);
    };
    Right.prototype.equals = function (other) {
        return other.isRight() ? this.__value === other.__value : false;
    };
    Right.prototype.chain = function (f) {
        return f(this.__value);
    };
    Right.prototype.join = function () {
        return this.__value;
    };
    Right.prototype.alt = function (_) {
        return this;
    };
    Right.prototype.reduce = function (reducer, initialValue) {
        return reducer(initialValue, this.__value);
    };
    Right.prototype.extend = function (f) {
        return right(f(this));
    };
    Right.prototype.unsafeCoerce = function () {
        return this.__value;
    };
    Right.prototype.caseOf = function (patterns) {
        return '_' in patterns ? patterns._() : patterns.Right(this.__value);
    };
    Right.prototype.leftOrDefault = function (defaultValue) {
        return defaultValue;
    };
    Right.prototype.orDefault = function (_) {
        return this.__value;
    };
    Right.prototype.orDefaultLazy = function (_) {
        return this.__value;
    };
    Right.prototype.leftOrDefaultLazy = function (getDefaultValue) {
        return getDefaultValue();
    };
    Right.prototype.ifLeft = function (_) {
        return this;
    };
    Right.prototype.ifRight = function (effect) {
        return effect(this.__value), this;
    };
    Right.prototype.toMaybe = function () {
        return Maybe_1.Just(this.__value);
    };
    Right.prototype.leftToMaybe = function () {
        return Maybe_1.Nothing;
    };
    Right.prototype.either = function (_, ifRight) {
        return ifRight(this.__value);
    };
    Right.prototype.extract = function () {
        return this.__value;
    };
    Right.prototype['fantasy-land/bimap'] = function (f, g) {
        return this.bimap(f, g);
    };
    Right.prototype['fantasy-land/map'] = function (f) {
        return this.map(f);
    };
    Right.prototype['fantasy-land/ap'] = function (other) {
        return this.ap(other);
    };
    Right.prototype['fantasy-land/equals'] = function (other) {
        return this.equals(other);
    };
    Right.prototype['fantasy-land/chain'] = function (f) {
        return this.chain(f);
    };
    Right.prototype['fantasy-land/alt'] = function (other) {
        return this.alt(other);
    };
    Right.prototype['fantasy-land/reduce'] = function (reducer, initialValue) {
        return this.reduce(reducer, initialValue);
    };
    Right.prototype['fantasy-land/extend'] = function (f) {
        return this.extend(f);
    };
    return Right;
}());
Right.prototype.constructor = exports.Either;
var Left = /** @class */ (function () {
    function Left(value) {
        this.__value = value;
    }
    Left.prototype.isLeft = function () {
        return true;
    };
    Left.prototype.isRight = function () {
        return false;
    };
    Left.prototype.toJSON = function () {
        return this.__value;
    };
    Left.prototype.inspect = function () {
        return "Left(" + JSON.stringify(this.__value) + ")";
    };
    Left.prototype.toString = function () {
        return this.inspect();
    };
    Left.prototype.bimap = function (f, _) {
        return left(f(this.__value));
    };
    Left.prototype.map = function (_) {
        return this;
    };
    Left.prototype.mapLeft = function (f) {
        return left(f(this.__value));
    };
    Left.prototype.ap = function (other) {
        return other.isLeft() ? other : this;
    };
    Left.prototype.equals = function (other) {
        return other.isLeft() ? other.__value === this.__value : false;
    };
    Left.prototype.chain = function (_) {
        return this;
    };
    Left.prototype.join = function () {
        return this;
    };
    Left.prototype.alt = function (other) {
        return other;
    };
    Left.prototype.reduce = function (_, initialValue) {
        return initialValue;
    };
    Left.prototype.extend = function (_) {
        return this;
    };
    Left.prototype.unsafeCoerce = function () {
        throw new Error('Either got coerced to a Left');
    };
    Left.prototype.caseOf = function (patterns) {
        return '_' in patterns ? patterns._() : patterns.Left(this.__value);
    };
    Left.prototype.leftOrDefault = function (_) {
        return this.__value;
    };
    Left.prototype.orDefault = function (defaultValue) {
        return defaultValue;
    };
    Left.prototype.orDefaultLazy = function (getDefaultValue) {
        return getDefaultValue();
    };
    Left.prototype.leftOrDefaultLazy = function (_) {
        return this.__value;
    };
    Left.prototype.ifLeft = function (effect) {
        return effect(this.__value), this;
    };
    Left.prototype.ifRight = function (_) {
        return this;
    };
    Left.prototype.toMaybe = function () {
        return Maybe_1.Nothing;
    };
    Left.prototype.leftToMaybe = function () {
        return Maybe_1.Just(this.__value);
    };
    Left.prototype.either = function (ifLeft, _) {
        return ifLeft(this.__value);
    };
    Left.prototype.extract = function () {
        return this.__value;
    };
    Left.prototype['fantasy-land/bimap'] = function (f, g) {
        return this.bimap(f, g);
    };
    Left.prototype['fantasy-land/map'] = function (f) {
        return this.map(f);
    };
    Left.prototype['fantasy-land/ap'] = function (other) {
        return this.ap(other);
    };
    Left.prototype['fantasy-land/equals'] = function (other) {
        return this.equals(other);
    };
    Left.prototype['fantasy-land/chain'] = function (f) {
        return this.chain(f);
    };
    Left.prototype['fantasy-land/alt'] = function (other) {
        return this.alt(other);
    };
    Left.prototype['fantasy-land/reduce'] = function (reducer, initialValue) {
        return this.reduce(reducer, initialValue);
    };
    Left.prototype['fantasy-land/extend'] = function (f) {
        return this.extend(f);
    };
    return Left;
}());
Left.prototype.constructor = exports.Either;
var left = function (value) { return new Left(value); };
exports.Left = left;
var right = function (value) { return new Right(value); };
exports.Right = right;
